/**
 * Permission Management Tab - Extracted from admin.tsx per ADR-039: Component Size Strategy
 * This component displays all system permissions organized by resource type
 */

import {
  Badge,
  Box,
  Card,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react"

import { useRBACPermissions } from "@/hooks/usePermissions"

export function PermissionManagementTab() {
  const { permissionGroups, isLoading } = useRBACPermissions()

  if (isLoading) {
    return (
      <Text p={4} textAlign="center" color="gray.500">
        Loading permissions...
      </Text>
    )
  }

  return (
    <Card.Root>
      <Card.Header>
        <Stack align="start" gap={1}>
          <Heading size="md">System Permissions</Heading>
          <Text color="gray.600">
            View all available permissions organized by resource type
          </Text>
        </Stack>
      </Card.Header>
      <Card.Body>
        <Stack gap={6} align="stretch">
          {(permissionGroups || []).map((group) => (
            <Box key={group.resource_type}>
              <Flex mb={3} gap={2} align="center">
                <Text fontSize="lg">{group.icon}</Text>
                <Heading size="sm" textTransform="capitalize">
                  {group.resource_type}
                </Heading>
                <Badge variant="outline">
                  {group.permissions.length} permissions
                </Badge>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} gap={3}>
                {group.permissions.map((permission) => (
                  <Card.Root key={permission.id} size="sm" variant="outline">
                    <Card.Body>
                      <Flex justify="space-between">
                        <Stack align="start" gap={1}>
                          <Badge colorScheme={group.color}>
                            {permission.name}
                          </Badge>
                          <Text fontSize="sm" color="gray.600">
                            {permission.description}
                          </Text>
                        </Stack>
                        <Badge
                          variant={
                            permission.is_system_permission
                              ? "solid"
                              : "outline"
                          }
                        >
                          {permission.is_system_permission
                            ? "System"
                            : "Custom"}
                        </Badge>
                      </Flex>
                    </Card.Body>
                  </Card.Root>
                ))}
              </SimpleGrid>
            </Box>
          ))}
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}
